import { HttpContextToken, HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { lastValueFrom, switchMap } from 'rxjs';
import { fromPromise } from 'rxjs/internal/observable/innerFrom';
import { AccessTokenService } from '../services/access-token.service';

export const NO_AUTH = new HttpContextToken(() => false);

const handle = async (req: HttpRequest<unknown>, next: HttpHandlerFn, token: string) => {
  try {
    const authorizedRequest = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });

    return await lastValueFrom(next(authorizedRequest));
  } catch (e) {
    // The backend rejects an invalid/stale token with a 403 even on public routes, so only that case is retried
    // anonymously. Any other error response (404, 409, ...) belongs to the caller and must not be swallowed.
    if (!(e instanceof HttpErrorResponse) || e.status !== HttpStatusCode.Forbidden) {
      throw e;
    }

    return await lastValueFrom(next(req));
  }
};

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(NO_AUTH)) {
    return next(req);
  }

  return fromPromise(inject(AccessTokenService).get()).pipe(switchMap((value) => fromPromise(handle(req, next, value))));
};
